import SharingOnTvApp from "./SharingOnTvApp.vue";
import { vueApp } from "../Common/vueApp";

export default vueApp(SharingOnTvApp);
